/**
 * Created by ganlu on 29/12/2016.
 */
class UserInfoService {

    constructor() {
        "ngInject";
        this.user = null;
    }

    setUser(user) {
        this.user = user;
    }

    isGuest() {
        return !(this.user && this.user.id);
    }

    isAuthor(original) {
        if (!original) return false
        return !this.isGuest() && this.user.id == original.user_id;
    }

    isOriginalOwner(original, reproduction) {
        if (!this.isGuest()) {
            if (this.user.id == original.user.id)
                return true;

               //  console.log(this.user.type)
               //  console.log(this.user.admin_id)
               //  console.log(this.user)
               //  console.log(original)
               //  console.log(reproduction)
               //  console.log(original.user.id)
               //  console.log("-------------")
            if (this.user.type == 1&&(original.reproduction&&this.user.admin_id == original.reproduction.user.id||this.user.admin_id == original.user.id)){//企业用户时  对同组织内多个角色 兼容 （不需要付钱获取授权）
                return true;
            }

            if (reproduction) {
                if (reproduction.user_id == this.user.id) {
                    return true;
                }
            }
        }

        return false;
    }
}

export default UserInfoService;




































// WEBPACK FOOTER //
// ./src/app/components/page/user-info.service.js